import i18n from "i18next";

const resources = {
  ar: {
    button_update_manually: "تحديث يدوي",
    msg_update_success: "تم تحديث العمليات بنجاح",
    msg_update_failed: "فشل التحديث",
    modal_title: "تحديث يدوي للعمليات المعلقة في الضمان",
    col_service_code: "رمز الخدمة",
    col_description: "الوصف",
    col_quantity: "الكمية",
    col_unit_price: "سعر الوحدة",
    label_insurance_value: "قيمة التأمين",
    label_discount: "الخصم",
    label_tax: "الضريبة",
    label_approved: "معتمد",
    button_cancel: "إلغاء",
    msg_invalid: "غير صالح",
    placeholder_insurance_value: "قيمة التأمين",
    placeholder_discount: "الخصم",
    placeholder_tax: "الضريبة",
    approvedSwitchTooltip: "قم بالتبديل لتحديد هذه الخدمة كمعتمدة وإدخال القيم المالية",
    approved: "معتمد",
    notApproved: "غير معتمد"
  },
  en: {
    button_update_manually: "Update Manually",
    msg_update_success: "Operations updated successfully",
    msg_update_failed: "Update failed",
    modal_title: "Manual Update Pending DHS Operations",
    col_service_code: "Service Code",
    col_description: "Description",
    col_quantity: "Quantity",
    col_unit_price: "Unit Price",
    label_insurance_value: "Insurance Value",
    label_discount: "Discount",
    label_tax: "Tax",
    label_approved: "Approved",
    button_cancel: "Cancel",
    msg_invalid: "Invalid",
    placeholder_insurance_value: "Insurance Value",
    placeholder_discount: "Discount",
    placeholder_tax: "Tax",
    approvedSwitchTooltip: "Toggle on to mark this service as approved and enter financial values",
    approved: "Approved",
    notApproved: "Not Approved"
  },
  ckb: {
    button_update_manually: "بە دەستی نوێی بکەرەوە",
    msg_update_success: "کارەکان بە سەرکەوتوویی نوێ کرانەوە",
    msg_update_failed: "نوێکردنەوە سەرکەوتوو نەبوو",
    modal_title: "نوێکردنەوەی دەستی بۆ کارە چاوەڕوانکراوەکانی DHS",
    col_service_code: "کۆدی خزمەتگوزاری",
    col_description: "وەسف",
    col_quantity: "بڕ",
    col_unit_price: "نرخی یەکە",
    label_insurance_value: "بەهای دەستەبەری (دڵنیایی)",
    label_discount: "داشکاندن",
    label_tax: "باج",
    label_approved: "پەسەندکراو",
    button_cancel: "پاشگەزبوونەوە",
    msg_invalid: "نادروستە",
    placeholder_insurance_value: "بەهای دەستەبەری",
    placeholder_discount: "داشکاندن",
    placeholder_tax: "باج",
    approvedSwitchTooltip: "پێبکە بۆ دیاریکردنی ئەم خزمەتگوزارییە وەک پەسەندکراو و داخڵکردنی نرخە داراییەکان",
    approved: "پەسەندکراو",
    notApproved: "پەسەندنەکراو"
  },
  el: {
    button_update_manually: "Μη αυτόματη ενημέρωση",
    msg_update_success: "Οι λειτουργίες ενημερώθηκαν με επιτυχία",
    msg_update_failed: "Η ενημέρωση απέτυχε",
    modal_title: "Μη αυτόματη ενημέρωση εκκρεμών λειτουργιών DHS",
    col_service_code: "Κωδικός υπηρεσίας",
    col_description: "Περιγραφή",
    col_quantity: "Ποσότητα",
    col_unit_price: "Τιμή μονάδας",
    label_insurance_value: "Αξία ασφάλισης",
    label_discount: "Έκπτωση",
    label_tax: "Φόρος",
    label_approved: "Εγκρίθηκε",
    button_cancel: "Ακύρωση",
    msg_invalid: "Μη έγκυρο",
    placeholder_insurance_value: "Αξία ασφάλισης",
    placeholder_discount: "Έκπτωση",
    placeholder_tax: "Φόρος",
    approvedSwitchTooltip: "Ενεργοποιήστε για να επισημάνετε αυτήν την υπηρεσία ως εγκεκριμένη και να εισαγάγετε οικονομικές αξίες",
    approved: "Εγκεκριμένο",
    notApproved: "Μη εγκεκριμένο"
  },
  fr: {
    button_update_manually: "Mettre à jour manuellement",
    msg_update_success: "Opérations mises à jour avec succès",
    msg_update_failed: "Échec de la mise à jour",
    modal_title: "Mise à jour manuelle des opérations DHS en attente",
    col_service_code: "Code de service",
    col_description: "Description",
    col_quantity: "Quantité",
    col_unit_price: "Prix unitaire",
    label_insurance_value: "Valeur d'assurance",
    label_discount: "Remise",
    label_tax: "Taxe",
    label_approved: "Approuvé",
    button_cancel: "Annuler",
    msg_invalid: "Invalide",
    placeholder_insurance_value: "Valeur d'assurance",
    placeholder_discount: "Remise",
    placeholder_tax: "Taxe",
    approvedSwitchTooltip: "Activez pour marquer ce service comme approuvé et saisir les valeurs financières",
    approved: "Approuvé",
    notApproved: "Non approuvé"
  },
  it: {
    button_update_manually: "Aggiorna manualmente",
    msg_update_success: "Operazioni aggiornate con successo",
    msg_update_failed: "Aggiornamento fallito",
    modal_title: "Aggiornamento manuale operazioni DHS in sospeso",
    col_service_code: "Codice servizio",
    col_description: "Descrizione",
    col_quantity: "Quantità",
    col_unit_price: "Prezzo unitario",
    label_insurance_value: "Valore assicurativo",
    label_discount: "Sconto",
    label_tax: "Tassa",
    label_approved: "Approvato",
    button_cancel: "Annulla",
    msg_invalid: "Non valido",
    placeholder_insurance_value: "Valore assicurativo",
    placeholder_discount: "Sconto",
    placeholder_tax: "Tassa",
    approvedSwitchTooltip: "Attiva per contrassegnare questo servizio come approvato e inserire i valori finanziari",
    approved: "Approvato",
    notApproved: "Non approvato"
  },
  ku: {
    button_update_manually: "Bi destan nû bike",
    msg_update_success: "Operasyon bi serkeftî hatin nûkirin",
    msg_update_failed: "Nûkirin bi ser neket",
    modal_title: "Nûkirina destan a operasyonên DHS yên li bendê",
    col_service_code: "Koda xizmetê",
    col_description: "Daxuyanî",
    col_quantity: "Hejmar",
    col_unit_price: "Bihayê yekeyê",
    label_insurance_value: "Bihayê sîgortayê",
    label_discount: "Daxistin",
    label_tax: "Bac",
    label_approved: "Pejirandin",
    button_cancel: "Betal bike",
    msg_invalid: "Nederbasdar",
    placeholder_insurance_value: "Bihayê sîgortayê",
    placeholder_discount: "Daxistin",
    placeholder_tax: "Bac",
    approvedSwitchTooltip: "Vê vekin da ku vê xizmetê wekî pejirandî nîşan bidin û nirxên darayî binivîsin",
    approved: "Pejirandî",
    notApproved: "Nepejirandî"
  },
  nl: {
    button_update_manually: "Handmatig bijwerken",
    msg_update_success: "Bewerkingen succesvol bijgewerkt",
    msg_update_failed: "Update mislukt",
    modal_title: "Handmatige update van openstaande DHS-bewerkingen",
    col_service_code: "Servicecode",
    col_description: "Beschrijving",
    col_quantity: "Aantal",
    col_unit_price: "Eenheidsprijs",
    label_insurance_value: "Verzekeringswaarde",
    label_discount: "Korting",
    label_tax: "Belasting",
    label_approved: "Goedgekeurd",
    button_cancel: "Annuleren",
    msg_invalid: "Ongeldig",
    placeholder_insurance_value: "Verzekeringswaarde",
    placeholder_discount: "Korting",
    placeholder_tax: "Belasting",
    approvedSwitchTooltip: "Schakel in om deze service als goedgekeurd te markeren en financiële waarden in te voeren",
    approved: "Goedgekeurd",
    notApproved: "Niet goedgekeurd"
  },
  pl: {
    button_update_manually: "Aktualizuj ręcznie",
    msg_update_success: "Operacje zaktualizowane pomyślnie",
    msg_update_failed: "Aktualizacja nie powiodła się",
    modal_title: "Ręczna aktualizacja oczekujących operacji DHS",
    col_service_code: "Kod usługi",
    col_description: "Opis",
    col_quantity: "Ilość",
    col_unit_price: "Cena jednostkowa",
    label_insurance_value: "Wartość ubezpieczenia",
    label_discount: "Rabat",
    label_tax: "Podatek",
    label_approved: "Zatwierdzony",
    button_cancel: "Anuluj",
    msg_invalid: "Nieprawidłowe",
    placeholder_insurance_value: "Wartość ubezpieczenia",
    placeholder_discount: "Rabat",
    placeholder_tax: "Podatek",
    approvedSwitchTooltip: "Włącz, aby oznaczyć tę usługę jako zatwierdzoną i wprowadzić wartości finansowe",
    approved: "Zatwierdzone",
    notApproved: "Niezatwierdzone"
  }
};

export const addTranslationResources = (i18next: typeof i18n) => {
  i18next.addResourceBundle("ar", "dhsManualUpdate", resources.ar);
  i18next.addResourceBundle("en", "dhsManualUpdate", resources.en);
  i18next.addResourceBundle("ckb", "dhsManualUpdate", resources.ckb);
  i18next.addResourceBundle("el", "dhsManualUpdate", resources.el);
  i18next.addResourceBundle("fr", "dhsManualUpdate", resources.fr);
  i18next.addResourceBundle("it", "dhsManualUpdate", resources.it);
  i18next.addResourceBundle("ku", "dhsManualUpdate", resources.ku);
  i18next.addResourceBundle("nl", "dhsManualUpdate", resources.nl);
  i18next.addResourceBundle("pl", "dhsManualUpdate", resources.pl);
};
